import { IMMERSIVE_VIEWER_MOBILE_MQ } from "../immersive-viewer-layout";

/** Phone + tablet: host + iframe fill the remaining viewport (no second page scroll). */
export const IFC_PHONE_MQ = IMMERSIVE_VIEWER_MOBILE_MQ;

/**
 * Remaining viewport height for the IFC host so the iframe is not a clipped
 * 70vh pane with a second page scroll underneath.
 */
export function computeIfcHostFillPx({ top, viewportHeight, bottomReserve = 0 }) {
  const topPx = Number(top);
  const vh = Number(viewportHeight);
  const bottom = Number(bottomReserve);
  if (!Number.isFinite(topPx) || !Number.isFinite(vh)) return 280;
  const reserve = Number.isFinite(bottom) ? Math.max(0, bottom) : 0;
  return Math.max(280, Math.round(vh - topPx - reserve));
}

/** Parse `--mobile-nav-height` (`3.75rem` / `60px`) into CSS pixels. */
export function cssLengthToPx(value, remPx = 16) {
  if (value == null) return 0;
  const raw = String(value).trim();
  if (!raw) return 0;
  if (raw.endsWith("rem")) {
    const n = Number.parseFloat(raw);
    return Number.isFinite(n) ? n * remPx : 0;
  }
  const n = Number.parseFloat(raw);
  return Number.isFinite(n) ? n : 0;
}
